const _languageKeys = {
  'tr': {
    'LOGO_URL': 'https://cdn.armut.com/images/armut-header-logo-colour@2x.png',
    'APP_NAME': 'Armut',
    'CANCEL': 'İptal',
    'CREATEDATE': 'Başlangıç',
    'CURRENT': 'Geçerli oturum',
    'DAYS': 'gün',
    'EMPTY_GRANTS': 'Başka oturum bulunmuyor.',
    'EXPIREDATE': 'Bitiş',
    'OTHER_GRANTS': 'Diğer oturumlar',
    'REVOKE': 'Sonlandır',
    'REVOKE_ALL': 'Tümünü Sonlandır',
    'TITLE': 'Aktif Oturumlar',
    'VALID_FOR': 'Geçerlilik'
  },
  'en': {
    'LOGO_URL': 'https://cdn.armut.com/images/ahomerun-header-logo-colour@2x.png',
    'APP_NAME': 'Homerun',
    'CANCEL': 'Cancel',
    'CREATEDATE': 'Created',
    'CURRENT': 'Current session',
    'DAYS': 'days',
    'EMPTY_GRANTS': 'No other sessions.',
    'EXPIREDATE': 'Expires',
    'OTHER_GRANTS': 'Other sessions',
    'REVOKE': 'Revoke',
    'REVOKE_ALL': 'Revoke All',
    'TITLE': 'Active Sessions',
    'VALID_FOR': 'Validity'
  },
  'ro': {
    'LOGO_URL': 'https://cdn.armut.com/images/ahomerun-header-logo-colour@2x.png',
    'APP_NAME': 'Homerun',
    'CANCEL': 'Anulează',
    'CREATEDATE': 'Creată',
    'CURRENT': 'Sesiunea curentă',
    'DAYS': 'zi',
    'EMPTY_GRANTS': 'Fără alte ședințe.',
    'EXPIREDATE': 'Expiră',
    'OTHER_GRANTS': 'Alte sesiuni',
    'REVOKE': 'Revoca',
    'REVOKE_ALL': 'Revoca toate',
    'TITLE': 'Sesiuni Active',
    'VALID_FOR': 'Valabilitate'
  },
  'sa': {
    'LOGO_URL': 'https://cdn.armut.com/images/ahomerun-header-logo-colour@2x.png',
    'APP_NAME': 'Homerun',
    'CANCEL': 'الغاء',
    'CREATEDATE': 'خلقت',
    'CURRENT': 'الجلسة الحالية',
    'DAYS': 'أيام',
    'EMPTY_GRANTS': 'لا جلسات أخرى.',
    'EXPIREDATE': 'تنتهي',
    'OTHER_GRANTS': 'جلسات أخرى',
    'REVOKE': 'الغاء',
    'REVOKE_ALL': 'إبطال الكل',
    'TITLE': 'جلسات العمل النشطة',
    'VALID_FOR': 'صلاحية'
  },
  'eg': {
    'LOGO_URL': 'https://cdn.armut.com/images/ahomerun-header-logo-colour@2x.png',
    'APP_NAME': 'Homerun',
    'CANCEL': 'الغاء',
    'CREATEDATE': 'خلقت',
    'CURRENT': 'الجلسة الحالية',
    'DAYS': 'أيام',
    'EMPTY_GRANTS': 'لا جلسات أخرى.',
    'EXPIREDATE': 'تنتهي',
    'OTHER_GRANTS': 'جلسات أخرى',
    'REVOKE': 'الغاء',
    'REVOKE_ALL': 'إبطال الكل',
    'TITLE': 'جلسات العمل النشطة',
    'VALID_FOR': 'صلاحية'
  },
  'pl': {
    'LOGO_URL': 'https://cdn.armut.com/images/ahomerun-header-logo-colour@2x.png',
    'APP_NAME': 'Homerun',
    'CANCEL': 'Anuluj',
    'CREATEDATE': 'Utworzony',
    'CURRENT': 'Bieżąca sesja',
    'DAYS': 'dni',
    'EMPTY_GRANTS': 'Żadnych innych sesji.',
    'EXPIREDATE': 'Wygasa',
    'OTHER_GRANTS': 'Inne sesje',
    'REVOKE': 'Odwołać',
    'REVOKE_ALL': 'Odwołaj wszystko',
    'TITLE': 'Aktywne Sesje',
    'VALID_FOR': 'Ważność'
  }
};

const _domainLanguageMap = {
  'armut': 'tr',
  'a': 'en',
  'us': 'en',
  'uk': 'en',
  'eg': 'eg',
  'sa': 'sa',
  'pl': 'pl',
  'ro': 'ro',
  'hu': 'hu',
  'at': 'at',
  'cs': 'cz'
};

const _domainTextDirectionMap = {
  'eg': 'rtl',
  'sa': 'rtl'
};

let _lang;
let _dir;

const getLanguageKeys = function () {
  if (!_lang) {
    const domain = getDomain();
    _lang = _domainLanguageMap[domain];
  }
  return _languageKeys[_lang] || _languageKeys['en'];
};

const getTextDirection = function () {
  if (!_dir) {
    const domain = getDomain();
    _dir = _domainTextDirectionMap[domain] || 'ltr';
  }
  return _dir;
};

const getDomain = function () {
  return window.location.host.replace(/(grants)|(homerun)|(test0?)|(stage)|(com?)|([.-])/gi, '');
};

export default { getLanguageKeys, getTextDirection, lang: _lang, direction: _dir };
